import React, { useState, useEffect } from 'react';
import AxiosOICStat from '../AxiosOICStat';
import { Select, Button, Row, Col, Tooltip, Checkbox, Card, Collapse, Switch, message } from 'antd';
import DataTable from '../components/DataTable';
import IndicatorSelector from '../components/IndicatorSelector';
import { useSelector } from 'react-redux';
import DatePicker from 'react-multi-date-picker';
import DatePanel from "react-multi-date-picker/plugins/date_panel"
import PresetValuesPlugin from '../components/datePickerPlugins/PresetValuesPlugin';
import Icon from "react-multi-date-picker/components/icon";
import { CarryForwardCheck } from 'components/CarryForwardCheck';
import CategoriesCollapse from 'components/CategoriesCollapse';
import * as XLSX from 'xlsx';
import { writeExcelFile } from '../utils/excelExport';
import { getIndicatorName } from '../utils/indicatorName';
import { useMemo } from 'react';

const { Option } = Select;

export function DataQuery({ auto_search = false }) {
    const [selectedCountries, setSelectedCountries] = useState([]);
    const [selectedIndicators, setSelectedIndicators] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedYears, setSelectedYears] = useState([]);
    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const countriesState = useSelector((state) => state.countries);
    const indicatorsState = useSelector((state) => state.indicators);
    const unitsState = useSelector((state) => state.units);
    const [regionMappingsData, setRegionMappingsData] = useState([]);
    const [countryMap, setCountryMap] = useState({});
    const [selectedRegions, setSelectedRegions] = useState([]);
    const [carryForwardCheck, setCarryForwardCheck] = useState(false);
    const [carryForwardBaseYear, setCarryForwardBaseYear] = useState('')
    const categoriesState = useSelector((state) => state.categories);
    const [keyIndicators, setKeyIndicators] = useState([]);
    const [isKeyIndicatorsFetching, setIsKeyIndicatorsFetching] = useState(false);
    const [fetchLatest, setFetchLatest] = useState(false);
    const [columns, setColumns] = useState([]);
    const [colYearView, setColYearView] = useState(false);

    const renderTagPlaceholder = (omittedValues) => {
        const sortedOmittedValues = [...omittedValues].sort((a, b) => parseInt(a.value) - parseInt(b.value));

        const fullList = sortedOmittedValues.map(val => val.label).join('\n');
        return (
            <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{fullList}</span>}>
                <span>{`+${omittedValues.length} more`}</span>
            </Tooltip>
        );
    };

    useEffect(() => {
        if (!auto_search) {

        }
        else {
            handleSearch();
        }
    }, [auto_search]);

    useEffect(() => {
        if(!isKeyIndicatorsFetching){
            AxiosOICStat.post('/secondary-categories/get-key-indicators').then(res => {
                setKeyIndicators(res.data);
            })
            setIsKeyIndicatorsFetching(true);
        } 
        console.log("Key Indicators",keyIndicators);
    }, [keyIndicators]);

    const handleSearch = () => {
        setLoading(true);
        const formattedYears = [];

        const missing = [];
        if(selectedYears.length == 0 && !fetchLatest){missing.push("year");}
        if (selectedIndicators.length === 0) missing.push("indicator");
        if (selectedCountries.length === 0) missing.push("country");

        if (missing.length > 0) {
                    message.warning(`Please select at least one ${missing.join(", ")}.`);
                    setLoading(false);
                    return;
        }

        selectedYears.forEach(range => {
            if (range.length === 2) {
                for (let i = range[0].year; i <= range[1].year; i++) {
                    formattedYears.push(i);
                }
            } else {
                formattedYears.push(range[0].year);
            }
        });

        const formattedCountries = selectedCountries.map(country => country.split(' - ')[0]);

        const formattedIndicators = selectedIndicators.map(indicator => indicator.split(' - ')[0]);

        if (fetchLatest) {
            AxiosOICStat.post('/data/get_latest_data', {
                countries: formattedCountries,
                indicators: formattedIndicators,
                first_year_range: [],
                last_year_range: []  
            }).then(response => {
                const updatedData = response.data.map((element, index) => {
                    
                    if(element.d_value == null || element.d_value === ''){
                        element.d_value = element.d_str_value || null;
                    } else {
                        element.d_value = Number(element.d_value);
                    }
                    element.key = index;
                    element.u_name = unitsState.value[element.u_code]?.unit_name_eng;
                    element.cat_name = categoriesState.value[element.cat_code]?.cat_name_eng;
                    return element;
                });
                setSearchResults(updatedData);
                setColumns(["c_name", "cat_name", "ind_name", "u_name", "d_date", "d_year", "d_value"])
                setColYearView(false);
                setLoading(false);
            }).catch(() => setLoading(false));
            return;
        }

        AxiosOICStat.post('/data/query', {
            countries: formattedCountries,
            indicators: formattedIndicators,
            years: formattedYears
        }).then(response => {
            const updatedData = response.data.map((element, index) => {
                
                if(element.d_value == null || element.d_value === ''){
                    element.d_value = element.d_str_value || null;
                } else {
                    element.d_value = Number(element.d_value);
                }
                element.key = index;
                element.u_name = unitsState.value[element.u_code]?.unit_name_eng;
                return element;
            });
            if(carryForwardCheck){
                executeCarryForward(updatedData);
            }
            console.log("check",updatedData)
            setSearchResults(updatedData);
            setLoading(false);
            setColumns(["c_name", "cat_name", "ind_name", "u_name", "d_date", "d_year", "d_value"]);
            setColYearView(true);
        });

    };

    const executeCarryForward = (updatedData) => {
        const mappedData = updatedData.reduce((acc, item) => {
            const key = `${item.c_code}_${item.ind_code}`;
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(item);
    
            return acc;
        }, {});
    
        for (const key in mappedData) {
            if (mappedData.hasOwnProperty(key)) {
                let carriedValue = 0;
                let carriedYear = 0;
                let carryFlag = false;
    
                mappedData[key].forEach(item => {
                    if (Number(item.d_year) >= Number(carryForwardBaseYear) && item.d_value != null) {
                        carriedValue = item.d_value;
                        carriedYear = item.d_year;
                        carryFlag = true;
                    } else if (Number(item.d_year) >= Number(carryForwardBaseYear) && item.d_value == null) {
                        if (carriedYear != 0 && carriedValue != 0) {
                            item.d_value = carriedValue;
                            item.d_date = 'Carried From ' + carriedYear;
                        }
                        else{
                            item.d_date = 'Data Not Available';
                            item.d_value = "..";
                        }
                    }
                    if (item.d_value == null) {
                        item.d_value = "..";
                        item.d_date = 'Data Not Available';
                    }
                });
    
                if (carryFlag == false) {
                    mappedData[key].forEach(item => {
                        item.d_value = "..";
                        item.d_date = 'Data Not Available';
                    });
                }
            }
        }
    }; 

    const handleCarryForward = (checked) => {
        console.log(checked)
        setCarryForwardCheck(checked);
    };

    const handleYearChange = (year) => {
        setCarryForwardBaseYear(year);
    }

    const exportCarryForwardExcel = () => {
        const fileName = "Carry-Forward Results";
    
        const customHeaders = [
            'Country Name', 'Indicator', 'Unit', 'Year', 'Date', 'Value'
        ];
    
        
        const modifiedData = searchResults.map(entry => ({
            'Country Name': entry.c_name,
            'Indicator': entry.ind_name,
            'Unit': entry.u_name,
            'Year': entry.d_year,
            'Date': entry.d_date,
            'Value': Number(entry.d_value)
        }));
    
        const worksheet = XLSX.utils.json_to_sheet(modifiedData);
    
        XLSX.utils.sheet_add_aoa(worksheet, [customHeaders], { origin: "A1" });
    
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    
        writeExcelFile(workbook, `${fileName}.xlsx`);
    };

    const exportLatestToExcel = () => {
        const fileName = "Latest Data Export";
        const customHeaders = [
            'Country Name', 'Category', 'Indicator Code', 'Indicator', 'Unit', 'Year', 'Date', 'Value'
        ];

        
        const modifiedData = searchResults.map(entry => ({
            'Country Name': entry.c_name,
            'Category': entry.cat_name,
            'Indicator Code': entry.ind_code,
            'Indicator': entry.ind_name,
            'Unit': entry.u_name,
            'Year': entry.d_year,
            'Date': entry.d_date,
            'Value': entry.d_value
        }));

        const worksheet = XLSX.utils.json_to_sheet(modifiedData);
        XLSX.utils.sheet_add_aoa(worksheet, [customHeaders], { origin: "A1" });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        writeExcelFile(workbook, `${fileName}.xlsx`);
    };

    const exportToExcel = () => {
        const formattedYears = [];
        console.log("SearchResults", searchResults);

        if(fetchLatest){
            exportLatestToExcel();
            return;
        }

        if(carryForwardCheck){
            exportCarryForwardExcel()
            return;
        }

        selectedYears.forEach(range => {
            if (range.length === 2) {
                for (let i = range[0].year; i <= range[1].year; i++) {
                    formattedYears.push(i);
                }
            } else {
                formattedYears.push(range[0].year);
            }
        });

        const formattedCountries = selectedCountries.map(country => country.split(' - ')[0]);

        const formattedIndicators = selectedIndicators.map(indicator => indicator.split(' - ')[0]);

        AxiosOICStat.post('/data/query-csv', {
            countries: formattedCountries,
            indicators: formattedIndicators,
            years: formattedYears,
            formatOptions: {}
        }).then(response => {
            const headers = [
                "Country", "Category", "Indicator Code", "Indicator", "Unit",
                ...formattedYears.map(year => year.toString())
            ];

            const dataForExport = response.data.map(item => {
                const row = {
                    "Country": item.c_name,
                    "Category": item.category,
                    "Indicator Code": item.ind_code,
                    "Indicator": item.ind_name,
                    "Unit": item.unit
                };
                item.years.forEach((value, index) => {
                    const year = formattedYears[index].toString();
                    row[year] = value != null ? value : '';
                });
                return row;
            });

            const worksheet = XLSX.utils.json_to_sheet(dataForExport, { header: headers });
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            writeExcelFile(workbook, 'oicstat_data.xlsx');
        });
    };

    useEffect(() => {
        setSelectedCountries(selectedCountries.sort((a, b) => parseInt(a) - parseInt(b)));
        setSelectedYears(selectedYears.sort((a, b) => parseInt(a) - parseInt(b)));
    },
        [selectedCountries, selectedIndicators, selectedYears]
    );

    useEffect(() => {
        const fetchRegionMappings = async () => {
            try {
                const response = await AxiosOICStat.get('/region-mappings/');
                setRegionMappingsData(response.data);
            } catch (error) {
                console.error('Failed to fetch region mappings:', error);
            }
        };

        fetchRegionMappings();
    }, []);

    const fetchRegionCountries = async (regionId) => {
        try {
            const response = await AxiosOICStat.get(`/regions-countries/${regionId}`); // Adjust the endpoint as needed
            return response.data; // Assuming the response body will be the array of country codes
        } catch (error) {
            console.error('Failed to fetch region countries:', error);
            // Handle errors, e.g., show notification
        }
    };


    const regions = [
        {
            id: 1,
            label: 'Regions',
            children: <Row gutter={[8, 8]}>
                {regionMappingsData && regionMappingsData.map((region) => (
                    <Col span={6} key={region.id}>
                        <Checkbox
                            key={region.id}
                            checked={selectedRegions.includes(region.id)}
                            onChange={(e) => {
                                fetchRegionCountries(region.id).then(countries => {
                                    let updatedCountries = countries.map(fetchedCountry => {
                                        // find the country object in `countriesState` by its ID
                                        let country = Object.values(countriesState.value)
                                            .filter(stateCountry => stateCountry.c_code === fetchedCountry.country_id)[0]

                                        if (country && country.c_short_name_eng) {
                                            country = country.c_short_name_eng;
                                        } else return '';
                                        return `${fetchedCountry.country_id} - ${country}`;
                                    });

                                    updatedCountries = updatedCountries.filter(country => country !== '');

                                    const differenceCountries = []

                                    if (e.target.checked) {
                                        setCountryMap(prevMap => {
                                            const newMap = { ...prevMap };
                                            updatedCountries.forEach(country => {
                                                if (newMap[country] === undefined || newMap[country] === 0) {
                                                    newMap[country] = 1;
                                                    differenceCountries.push(country);
                                                } else {
                                                    newMap[country] += 1;
                                                }
                                            });
                                            return newMap;
                                        });
                                    } else {
                                        setCountryMap(prevMap => {
                                            const newMap = { ...prevMap };
                                            updatedCountries.forEach(country => {
                                                if (newMap[country] > 1) {
                                                    newMap[country] -= 1;
                                                } else {
                                                    newMap[country] = 0;
                                                    differenceCountries.push(country);
                                                }
                                            });
                                            return newMap;
                                        });
                                    }

                                    // handle checkbox change
                                    setSelectedRegions(e.target.checked
                                        ? [...selectedRegions, region.id]
                                        : selectedRegions.filter(selectedRegion => selectedRegion !== region.id)
                                    );

                                    setSelectedCountries(prevCountries => {
                                        if (e.target.checked) {
                                            return [...new Set([...prevCountries, ...differenceCountries])];
                                        } else {
                                            return prevCountries.filter(country => !differenceCountries.includes(country));
                                        }
                                    });

                                });
                            }}
                            value={region.id}
                        >
                            {region.region_name}
                        </Checkbox>
                    </Col>
                ))}
            </Row>
        }
    ]

    const handleCategoryChange = (categoryId, isChecked) => {
        console.log(indicatorsState.value)
        const indicatorsInCategory = Object.values(indicatorsState.value || {}).filter(
            (indicator) => indicator.cat_code === categoryId || indicator.category_codes.includes(categoryId)
        ).map((indicator) => `${indicator.ind_code} - ${getIndicatorName(indicator)}`); // Match Select items' format
    
        if (isChecked) {
            // Add category and its indicators
            if(categoryId === 32){
                const formattedKeyIndicators = keyIndicators.map(
                    (indicator) => `${indicator.ind_code} - ${getIndicatorName(indicatorsState.value[indicator.ind_code] || indicator)}`
                );
                setSelectedCategories((prev) => [...prev, categoryId]);
                setSelectedIndicators((prev) => [...new Set([...prev, ...formattedKeyIndicators])]);
            }
            else if(categoryId === 27){
                setSelectedCategories((prev) => [...prev, categoryId]);
            }
            else{
                setSelectedCategories((prev) => [...prev, categoryId]);
                setSelectedIndicators((prev) => [...new Set([...prev, ...indicatorsInCategory])]);
            }
        } else {

            if(categoryId === 32){
                const formattedKeyIndicators = keyIndicators.map(
                    (indicator) => `${indicator.ind_code} - ${getIndicatorName(indicatorsState.value[indicator.ind_code] || indicator)}`
                );
                setSelectedCategories((prev) => prev.filter((id) => id !== categoryId));
                setSelectedIndicators((prev) =>
                    prev.filter((indicator) => !formattedKeyIndicators.includes(indicator))
                );
            }
            setSelectedCategories((prev) => prev.filter((id) => id !== categoryId));
            setSelectedIndicators((prev) =>
                prev.filter((indicator) => !indicatorsInCategory.includes(indicator))
            );
        }
    };

    const handleGoalSelected = (categoryId, goals) => {
        const currentIndicators = selectedIndicators;
        const goalsArray = Array.isArray(goals) ? goals : (goals ? [goals.toString()] : []);
        
        const allSdgPatterns = Array.from({length: 17}, (_, i) => new RegExp(`^SDG\\s*0*${i+1}\\.`, 'i'));
        const allSdgIndicators = Object.values(indicatorsState.value || {}).filter(
            (indicator) => allSdgPatterns.some(pattern => pattern.test(indicator.ind_name_eng))
        ).map((indicator) => `${indicator.ind_code} - ${getIndicatorName(indicator)}`);

        const selectedPatterns = goalsArray.map(goal => new RegExp(`^SDG\\s*0*${goal}\\.`, 'i'));
        const selectedSdgIndicators = Object.values(indicatorsState.value || {}).filter(
            (indicator) => selectedPatterns.some(pattern => pattern.test(indicator.ind_name_eng))
        ).map((indicator) => `${indicator.ind_code} - ${getIndicatorName(indicator)}`);

        const filteredIndicators = currentIndicators.filter(ind => !allSdgIndicators.includes(ind));
        setSelectedIndicators([...new Set([...filteredIndicators, ...selectedSdgIndicators])]);
    };

    return (
        <>
            {!auto_search &&
                <Col style={{ marginBottom: '10px' }}>
                    <Collapse size="small" items={regions} bordered={false} style={{ marginBottom: "10px", width: "100%", backgroundColor: "white" }} />
                    <CategoriesCollapse selectedCategories={selectedCategories} onChange={handleCategoryChange} onGoalSelected={handleGoalSelected} />
                    <br></br>
                    <Row style={{marginBottom: '10px'}}>
                        <CarryForwardCheck carryForwardCheck={carryForwardCheck} onYearChange={handleYearChange} onSwitchChange={handleCarryForward} isDisabled={fetchLatest}></CarryForwardCheck>
                    </Row>
                    <Row style={{ marginBottom: '10px', width: 'fit-content' }}>
                        <Switch
                            checked={fetchLatest}
                            onChange={setFetchLatest}
                            checkedChildren="Last Available Data"
                            unCheckedChildren="Last Available Data"
                            style={{ marginRight: 10, width: '150px' }}
                            disabled={carryForwardCheck}
                        />
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <div style={{alignItems:"center", justifyContent:"center", alignSelf:"center", marginRight:"5px"}}>
                            <Switch
                                checked={carryForwardCheck}
                                onChange={handleCarryForward}
                                checkedChildren={<span>Carry Forward On</span>}
                                unCheckedChildren={<span>Carry Forward Off</span>}
                                style={{ marginRight: 10, width: '150px' }}
                            />
                        </div>
                        {carryForwardCheck && (
                            <DatePicker
                            onlyYearPicker
                            placeholder='Base Year'
                            style={{ marginLeft: '5px', width: '120px' }}
                            />
                        )}
                        </div>
                    </Row>
                    <Row>
                        <Select
                            mode="multiple"
                            placeholder="Select Countries"
                            onChange={setSelectedCountries}
                            maxTagCount={2}
                            maxTagPlaceholder={renderTagPlaceholder}
                            style={{ minWidth: '200px', marginBottom: '5px', marginRight: '10px' }}
                            showSearch
                            autoClearSearchValue={false}
                            value={selectedCountries}
                        >
                            {Object.values(countriesState.value)
                                .filter(country => selectedCountries.includes(String(country.c_code)))
                                .concat(Object.values(countriesState.value).filter(country => !selectedCountries.includes(String(country.c_code))))
                                .map(country => <Option key={country.c_code} value={`${country.c_code} - ${country.c_short_name_eng}`}>{`${country.c_code} - ${country.c_short_name_eng}`}</Option>)}
                        </Select>
                        <IndicatorSelector
                          indicators={Object.values(indicatorsState.value || {})}
                          selectedIndicators={selectedIndicators}
                          onChange={setSelectedIndicators}
                          minWidth="500px"
                        />

                        <Button disabled={fetchLatest} shape="circle" value="large" type="primary" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <DatePicker
                                onlyYearPicker
                                multiple
                                range
                                sort
                                highlightToday={false}
                                placeholderText={"Please select a date"}
                                selected={selectedYears}
                                value={selectedYears}
                                onChange={setSelectedYears}
                                maxDate={new Date()}
                                minDate={new Date(1970, 0, 1)}
                                plugins={[
                                    <DatePanel />,
                                    <PresetValuesPlugin position="left" setValue={setSelectedYears} />,
                                ]}
                                render={<Icon style={{ color: 'white', width: '85%', marginTop: '2px' }} />}
                            />
                        </Button>
                        
                        <Button type="primary" onClick={handleSearch} style={{ marginLeft: '10px', }}>Search</Button>
                        <Button onClick={exportToExcel} disabled={searchResults.length === 0} type="primary" style={{ marginLeft: '10px' }}>Export</Button>
                    </Row>
                </Col>
            }
            <Row>
                <Col xs={24}>
                    <DataTable data={searchResults} columns={columns} widths={['10%', '60%', '10%', '10%']} loading={loading}  
                     decimalSymbol={"."}/>
                </Col>
            </Row>
        </>
    );
};